<template>
    <evp-layout>
        <div class="bg-surface shadow-small rounded-md flex flex-col md:flex-row justify-center items-center mt-8 xl:mt-16">
            <img 
                src="@/images/landing-login.png"
                class="w-full max-w-[320px] md:max-w-[400px] md:ml-5 xl:ml-32 md:mr-5"
            />
            <div class="grow py-5 p-6 lg:py-10 flex items-center justify-center w-full">
                <login-form />
            </div>
        </div>
    </evp-layout>
</template>
<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
    import LoginForm from '@/components/home/LoginForm.vue'
</script>